import cookieUniversal from 'cookie-universal';
export default ((_ref, inject) => {
  let {
    req,
    res
  } = _ref;
  const options = {
    "alias": "cookies",
    "parseJSON": true
  };
  inject(options.alias, cookieUniversal(req, res, options.parseJSON));
});